import {Typography} from "@mui/material";

export const PlatformInfoContent = () => {



    return {
        title: 'Platforms',
        content: (
            <>
                <Typography paragraph>
                    Platforms represent the distribution channels,
                    services, outlets, and classifications through
                    which products are exhibited, consumed, or tracked
                    within the system.
                </Typography>

                <ul>
                    <li>
                        A Platform can represent a television network,
                        cable channel, streaming service, AVOD service,
                        FAST channel, or other distribution
                        destination.
                    </li>

                    <li>
                        Platforms can also represent classifications
                        that are not traditional distribution channels,
                        such as award categories or other reporting
                        groupings that may have Usage or Viewership
                        records associated with them.
                    </li>

                    <li>
                        Any entity that will have Usage, Viewership,
                        Subscriber, or other activity records linked
                        to it should have a corresponding Platform
                        record.
                    </li>

                    <li>
                        Platform data is commonly referenced by
                        Usage, Viewership, Subscriber,
                        Financial, and obligation calculations
                        throughout the system.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Platform records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Platform data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Platform manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Platform records.
                    </li>

                    <li>
                        Maintaining consistent Platform definitions
                        helps ensure accurate reporting, aggregation,
                        filtering, and calculation of activity across
                        all products and distribution channels.
                    </li>
                </ul>
            </>
        )
    };
};









